import React from "react";
import { Box } from "@mui/material";
import { Translations } from "ui/Scripts/source/models/translations";

interface IDocumentFolderPath {
    path: string;
}

export const DocumentFolderPath = (props: IDocumentFolderPath) => {
    if (!props.path) return null;
    return (
        <Box sx={{ fontSize: "0.75rem", overflow: "hidden", marginTop: "5px" }} title={`${Translations.FolderPath}: ${props.path}`}>{`(${props.path})`}</Box>
    );
};